import React, { useEffect } from 'react';

import LocationFilter from './LocationFilter';
import AgeFilter from './AgeFilter';
import CategoryFilter from './CategoryFilter';
import PropertiesFilter from './PropertiesFilter';

import { Button } from '../Common/Button';
import { useFilters } from '../../hooks/useFilters';

import { Clear, Check, Cross, Wheelchair_Blue } from '../Icons/CustomIcons';
import CloseModalButton from '../Common/CloseModalButton';
import { WheelchairCheckbox } from '../Common/WheelchairCheckbox';
import { FreeAccessibleCheckbox } from '../Common/FreeAccessibleCheckbox';

const FilterModal = ({ open, onOpenChange }) => {
  const { resetFilters, filters, updateFilter } = useFilters();

  useEffect(() => {
    document.body.classList.toggle('drawer-open', open);
    return () => document.body.classList.remove('drawer-open');
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="drawer-overlay"
      onClick={() => onOpenChange(false)}
      role="dialog"
      aria-modal="true"
      aria-label="Filter"
    >
      <div
        className="drawer-panel"
        onClick={(e) => e.stopPropagation()}
      >
        <CloseModalButton
          className="drawer-close"
          onClick={() => onOpenChange(false)}
          ariaLabel="Filter schliessen"
        >
          <Cross size={20} />
        </CloseModalButton>

        <div className="filter-page">
          <h2 className="headings Font-H3-A-130-T Colors-Black">Ergebnisse filtern</h2>
          <p className="body Font-M-B-130-T Colors-Grey-06">Finden Sie genau das, was Sie suchen.</p>
        </div>
        <div className="filters">
          <WheelchairCheckbox
            checked={filters.wheelchair_accessible || false}
            onCheckedChange={(checked) => updateFilter('wheelchair_accessible', checked)}
            icon={Wheelchair_Blue}
          />          
          <FreeAccessibleCheckbox
            checked={filters.event_type === 'freely_accessible'}
            onCheckedChange={(checked) => updateFilter('event_type', checked ? 'freely_accessible' : null)}    
          />
          <LocationFilter />
          <AgeFilter />
          <CategoryFilter />
          <PropertiesFilter />
        </div>

        <div className="filter-drawer-actions">
          <Button variant="outline" onClick={resetFilters} className="filter-reset-btn">
            <Clear size={20} color="var(--Colors-Accent-01)" className="filter-reset-icon" />
            <span className="filter-reset-text">Alle Filter löschen</span>
          </Button>
          <Button onClick={() => onOpenChange(false)} className="filter-apply-btn">
            <Check size={20} />
            Filter anwenden
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;
